import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'

import Vue from 'vue'

import './rules'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
